import { Navigate } from "react-router-dom";

/**
 * Die Vertragsliste lebt jetzt als Tab in der Wartungsübersicht (`/wartungen?tab=vertraege`).
 * Alte Links bleiben über diese Weiterleitung gültig.
 */
export function VertraegePage() {
  return <Navigate to="/wartungen?tab=vertraege" replace />;
}
